document.addEventListener('DOMContentLoaded', function () {
  const hamperSelector = document.getElementById('hamper-selector');
  if (!hamperSelector) return;

  const addToCartBtn = document.querySelector('[data-type="add-to-cart-form"] button[name="add"]');
  if (addToCartBtn) addToCartBtn.setAttribute('type', 'button');

  // Selection logic
  const options = hamperSelector.querySelectorAll('.hamper-option');
  options.forEach(option => {
    option.addEventListener('click', function () {
      if (this.classList.contains('hamper-option--sold-out')) return;
      const slotNumber = this.dataset.slot;
      hamperSelector.querySelectorAll(`.hamper-option[data-slot="${slotNumber}"]`)
        .forEach(opt => opt.classList.remove('selected'));
      this.classList.add('selected');
      const input = document.getElementById(`slot-${slotNumber}-value`);
      if (input) input.value = this.dataset.title;
      const slot = hamperSelector.querySelector(`.hamper-slot[data-slot="${slotNumber}"]`);
      if (slot) { slot.style.border = 'none'; slot.style.padding = '0'; }
    });
  });

  if (!addToCartBtn) return;

  addToCartBtn.addEventListener('click', async function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    const slots = hamperSelector.querySelectorAll('.hamper-slot');
    let allSelected = true;
    let properties = {};

    slots.forEach(slot => {
      const slotNum = slot.dataset.slot;
      const input = document.getElementById(`slot-${slotNum}-value`);
      const labelEl = slot.querySelector('.hamper-slot__label');
      const labelText = labelEl ? labelEl.textContent.replace('*', '').trim() : `Slot ${slotNum}`;
      if (!input || !input.value) {
        allSelected = false;
        slot.style.border = '2px solid #e74c3c';
        slot.style.borderRadius = '8px';
        slot.style.padding = '8px';
      } else {
        properties[labelText] = input.value;
        const selectedOption = slot.querySelector('.hamper-option.selected');
        if (selectedOption && selectedOption.dataset.productId) {
          properties[`_${slotNum}_product_id`] = selectedOption.dataset.productId;
        }
      }
    });

    if (!allSelected) {
      alert('Please select an item before adding to cart.');
      return;
    }

    const form = document.querySelector('[data-type="add-to-cart-form"]');
    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;
    const variantId = variantInput.value;

    const qtyInput = form.querySelector('[name="quantity"]');
    const quantity = qtyInput ? parseInt(qtyInput.value) : 1;

    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity, properties: properties })
      });

      if (response.ok) {
        window.location.href = '/cart';
      } else {
        alert('Error adding to cart. Please try again.');
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to Cart';
      }
    } catch (err) {
      alert('Error adding to cart. Please try again.');
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Add to Cart';
    }
  }, true);

  // Batched image + stock fetch (max 5 parallel)
  async function fetchInBatches(elements, batchSize = 5) {
    for (let i = 0; i < elements.length; i += batchSize) {
      const batch = Array.from(elements).slice(i, i + batchSize);
      await Promise.all(batch.map(async el => {
        const handle = el.dataset.fetchImage;
        try {
          const res = await fetch(`/products/${handle}.js`);
          const product = await res.json();

          // Stock check
          const variant = product.variants && product.variants[0];
          const isOutOfStock = variant &&
            variant.inventory_quantity <= 0 &&
            variant.inventory_policy !== 'continue';

          if (isOutOfStock) {
            const hamperOption = el.closest('.hamper-option');
            if (hamperOption) {
              hamperOption.classList.add('hamper-option--sold-out');
              hamperOption.style.opacity = '0.5';
              hamperOption.style.cursor = 'not-allowed';
              hamperOption.style.position = 'relative';
              hamperOption.style.pointerEvents = 'none';

              const badge = document.createElement('div');
              badge.textContent = 'Sold Out';
              badge.style.cssText = `
                position: absolute;
                top: 8px;
                right: 8px;
                background: #e74c3c;
                color: #fff;
                font-size: 11px;
                font-weight: bold;
                padding: 2px 8px;
                border-radius: 4px;
                z-index: 10;
                pointer-events: none;
              `;
              hamperOption.appendChild(badge);
            }
          }

          if (product.featured_image) {
            const img = document.createElement('img');
            img.src = product.featured_image;
            img.alt = product.title;
            img.loading = 'lazy';
            img.width = 200;
            img.height = 200;
            img.style.width = '100%';
            img.style.height = '100%';
            img.style.objectFit = 'cover';
            el.innerHTML = '';
            el.appendChild(img);
          }
        } catch(e) {}
      }));
    }
  }

  const imageEls = document.querySelectorAll('[data-fetch-image]');
  if (imageEls.length) fetchInBatches(imageEls, 5);

});
